/**
 * Shared e-mail validation. Used by both the standalone email step and the
 * in-consent email field (askForEmailInConsent venues), so the two entry
 * points can never drift in what they accept.
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value);
}
